/**
 * The placeholder tile shown while an image is being generated.
 *
 * Generation runs ~15-20s, which is long enough that a button spinner alone
 * reads as nothing happening — hence a tile the same size as a real thumbnail,
 * in the photo row the user is actually looking at.
 *
 * Shared by the event's own photo row and the second listing's single photo, so
 * the two controls cannot drift into looking like different features.
 */
const GeneratingPhotoSkeleton = () => (
  <div
    role="status"
    aria-label="Generating image"
    className="relative w-24 h-24 rounded-md shadow-md overflow-hidden bg-gray-200 dark:bg-gray-700 animate-pulse flex flex-col items-center justify-center gap-1"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-gray-400 dark:text-gray-500"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13 10V3L4 14h7v7l9-11h-7z"
      />
    </svg>
    <span className="text-[10px] font-medium text-gray-500 dark:text-gray-400">
      Generating
    </span>
  </div>
);

export default GeneratingPhotoSkeleton;
